import l from "dayjs";
const y = (p = [], t) => {
  if (Object.keys(t).length === 0) return;
  let r = "", s = "";
  const f = t.optionType === "1" ? "Bear" : "Bull", n = l.unix(
    t.exerciseTimestamp.length !== l().valueOf().toString().length ? Number(t.exerciseTimestamp) : Number(t.exerciseTimestamp) / 1e3
  ), m = n.startOf("month"), d = m.add(1, "month");
  let o = 0, i = 0;
  for (let e = m; e.isBefore(d); e = e.add(1, "day"))
    e.date() === n.date() && (i = o), e.day() === 5 && o++;
  i === 0 ? r = "Alpha" : i === 1 ? r = "Beta" : i === 2 ? r = "Delta" : i === 3 ? r = "Gamma" : r = "Omega";
  const c = p.filter(
    (e) => e.optionType === t.optionType && e.exerciseTimestamp === t.exerciseTimestamp
  ).sort((e, u) => Number(e.strikePrice) - Number(u.strikePrice)), a = c.findIndex(
    (e) => e.strikePrice === t.strikePrice
  );
  return a < c.length - 1 && a > 0 ? s = "Grand" : s = a === 0 ? "Deluxe" : "Supreme", `${r} ${s} ${f}`;
};
export {
  y as useSniperNickname
};
//# sourceMappingURL=sniperNameFormat.mjs.map
